var React = require('react');

function IconLinkArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m720 193h-4.427557v1.100345h2.538097l-3.11054 3.121711.782571.777944 3.11054-3.121711v2.523092h1.106889z","fill":"#26c66a","fillRule":"evenodd","transform":"translate(-715 -193)"}));
}

IconLinkArrow.defaultProps = {"height":"5","viewBox":"0 0 5 5","width":"5"};

module.exports = IconLinkArrow;

IconLinkArrow.default = IconLinkArrow;
